import { Tag } from "antd";
import { CSSProperties, ReactNode } from "react";

interface HoverTagProps {
  style?: CSSProperties;
  hoverColor?: string;
  color?: string;
  className?: string;
  onClick?: () => void;
  children: string | React.ReactElement;
  icon?: ReactNode;
}

export function HoverTag({
  style,
  hoverColor,
  color,
  className,
  onClick,
  children,
  icon,
}: HoverTagProps) {
  return (
    <Tag
      className={className}
      style={{
        marginRight: 8,
        cursor: onClick ? "pointer" : undefined,
        ...style,
      }}
      color={color}
      onClick={onClick}
      icon={icon}
    >
      {children}
    </Tag>
  );
}
